import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/_auth/catalog/add-ons/create')({
  component: CreateAddonRouteComponent,
})

function CreateAddonRouteComponent() {
  const navigate = useNavigate()

  // Redirect to the main addons page - users can click "Create Addon" button there
  useEffect(() => {
    navigate({ to: '/catalog/add-ons', replace: true })
  }, [navigate])

  return null
}
